import React from 'react'
import { Modal, Button, ModalInjectedProps } from '@sketch/components'
import { useSendPasswordSetupEmailMutation } from '@sketch/gql-types'
import { useToast } from '@sketch/toasts'

interface AddEmailPasswordMethodModalProps extends ModalInjectedProps {}

/**
 * Modal for adding Email & Password sign-in method
 * Allows user to receive a link to set up password authentication
 */
export const AddEmailPasswordMethodModal: React.FC<
  AddEmailPasswordMethodModalProps
> = ({ hideModal }) => {
  const { showToast } = useToast()

  const [sendPasswordSetupEmail, { loading }] =
    useSendPasswordSetupEmailMutation({
      onCompleted: () => {
        showToast('Password email sent, please check your inbox', 'positive')
        hideModal()
      },
      onError: 'show-toast',
    })

  const handleEmailMeLink = () => {
    sendPasswordSetupEmail()
  }

  return (
    <Modal title="Add Email & Password Sign In Method" onCancel={hideModal}>
      <Modal.Body>
        We&apos;ll send a link to the current email address you have for your
        account. Follow that link to set a password.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={hideModal}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleEmailMeLink} loading={loading}>
          Email Me a Link
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
